import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["how-little-training-keeps-fitness"]!;

export function Body() {
  return (
    <>
      <p>
        Work, family or an exam period can leave much less time for running. How little
        training do you need to keep the fitness you have built? A series of classic studies
        tested it by cutting one thing at a time.
      </p>

      <h2>What the researchers did</h2>
      <p>
        In three studies from the early 1980s, young adults trained hard for ten weeks: 40
        minutes of running and cycling, six days a week. For the next 15 weeks, they cut back.
        In the first study they trained fewer days, in the second shorter sessions, and in the
        third at a lower intensity. Everything else stayed the same.
      </p>

      <h2>What they found</h2>
      <p>
        Fewer days: training two or four days a week instead of six kept maximal oxygen uptake
        at the trained level for all 15 weeks.
      </p>
      <p>
        Shorter sessions: 26 or 13 minutes instead of 40 also kept maximal oxygen uptake. With
        26 minutes, endurance over two hours or more was kept too. With 13 minutes, it fell by
        about 10 percent.
      </p>
      <p>
        Lower intensity: when the sessions were done at an easier effort, maximal oxygen uptake
        dropped, and endurance over two hours or more fell by 21 to 30 percent.
      </p>
      <p>
        A later review of research on reduced training reached the same conclusion: most of the
        fitness can be kept as long as intensity is maintained and the number of sessions is
        only moderately reduced. The total amount of training can be cut markedly.
      </p>

      <h2>What it means for you</h2>
      <p>
        In a busy period, keep some of the harder running and cut the amount. Two or three
        shorter sessions a week that still include some faster running hold on to more than
        easy jogs alone.
      </p>
      <p>
        If you have a long race coming up, endurance over many hours is the part that fades
        first when sessions get very short. Try to keep one longer run when you can.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        The participants were young adults who had trained for only ten weeks, not runners
        with years of training. The studies were small, and the training combined running and
        cycling.
      </p>

      <h2>How we use it</h2>
      <p>
        When you have less time, PX7 Training shortens your sessions and keeps the work that
        matters most for your goal. The plan adjusts to the time you have, and your next runs
        start from what you have actually done.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Hickson & Rosenkoetter (1981), Reduced training frequencies and maintenance of
          increased aerobic power.{" "}
          <a href="https://pubmed.ncbi.nlm.nih.gov/7219129/">Medicine & Science in Sports & Exercise</a>.
        </li>
        <li>
          Hickson et al. (1982), Reduced training duration effects on aerobic power, endurance,
          and cardiac growth.{" "}
          <a href="https://doi.org/10.1152/jappl.1982.53.1.225">Journal of Applied Physiology</a>.
        </li>
        <li>
          Hickson et al. (1985), Reduced training intensities and loss of aerobic power,
          endurance, and cardiac growth.{" "}
          <a href="https://doi.org/10.1152/jappl.1985.58.2.492">Journal of Applied Physiology</a>.
        </li>
        <li>
          Mujika & Padilla (2000), Detraining: loss of training-induced physiological and
          performance adaptations. Part II: long term insufficient training stimulus.{" "}
          <a href="https://doi.org/10.2165/00007256-200030030-00001">Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
